module.exports = __webpack_public_path__ + "static/media/acerta-checkmark.3e5eac7c.svg";